import { type GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCustomer, selectPartner } from 'redux-stores/slices/authSlice';

interface GrowthBookContainerProps {
  children?: React.ReactNode;
  gbInstance: GrowthBook;
}

function GrowthBookContainer({ children, gbInstance }: GrowthBookContainerProps) {
  const customer = useSelector(selectCustomer);
  const originApp = useSelector(selectPartner);

  useEffect(() => {
    if (!customer) {
      return;
    }
    const currentAttributes = gbInstance.getAttributes();

    const userAttributes: Record<string, unknown> = {
      ...customer.attributes,
      origin_app: originApp,
    };

    if (currentAttributes.id === userAttributes.id) {
      return;
    }

    gbInstance.setAttributes(userAttributes);
  }, [gbInstance, customer?.id, originApp]);

  return <GrowthBookProvider growthbook={gbInstance}>{children}</GrowthBookProvider>;
}

export { GrowthBookContainer };
